<template>
    <div>
        <div class="top-box">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>场地管理</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="tab-list d_flex a_c ">
                <h2>场地案例</h2>
                <div class="item" @click="back"><i class="icon el-icon-caret-left" type="primary"></i>场地列表</div>
                <div class="item" @click="addCase"><i class="icon el-icon-circle-plus-outline" type="primary"></i>新增案例</div>
            </div>
        </div>
        <div class="page-content p20">
            <div class="box bg_fff p20">
                <el-table
                        :data="tableData"
                        border
                        loading="loading"
                        style="width: 100%">
                    <el-table-column
                            prop="name"
                            align="center"
                            label="场地名称"
                            width="120"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="title"
                            align="center"
                            label="案例标题"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            prop="intro"
                            label="案例介绍"
                            align="center"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            prop="cover"
                            align="center"
                            label="案例相册">
                        <template slot-scope="scope" >
                            <img v-for="item in scope.row.imgs" :src="item|handleImg" alt="" style="width: 50px;height: 50px;margin: 0 5px;">
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="cover"
                            align="center"
                            label="案例视频"
                            width="100"
                    >
                        <template slot-scope="scope" >
                            <el-button v-if="scope.row.video&&scope.row.video.length>0" type="text" size="small" @click="openVideo(scope.row)">修改</el-button>
                            <span v-else style="color: #999;">暂无视频</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="create_time"
                            align="center"
                            label="案例时间"
                            width="100"
                    >
                    </el-table-column>
                    <el-table-column
                            prop=""
                            align="center"
                            label="操作"
                            width="100"
                    >
                        <template slot-scope="scope" >
                            <el-button type="text" size="small" @click="updateCase(scope.row)">修改</el-button>
                            <el-button type="text" size="small" @click="deleteCase(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
    import {SiteCase,deleteSiteCase} from '../../api/site'
    import {mapState} from "vuex";
    export default {
        name: "index",
        data(){
            return{
                tableData:[],
                loading:false,
                space_id:'',
                sc_name:'',
                page:1,
                pages:1,
                site_page:1,
            }
        },
        created(){
            this.space_id=this.$route.query.id;
            this.sc_name=this.$route.query.name;
            this.site_page=this.$route.query.page;
            this.getCase();
        },
        computed:{
            ...mapState(['baseUrl','cityArr'])
        },
        methods:{
            back(){
                this.$router.push({path: '/site/site',query:{page:this.site_page}});
            },
            getCase(){
                this.loading=true;
                SiteCase({
                    space_id:this.space_id,
                }).then(res=>{
                    this.loading=false;
                    if(res.code==1){
                        this.tableData=res.data.list;
                        this.pages=res.data.totalNum;
                        this.tableData=this.tableData.map(val=>{
                            val.name=this.sc_name;
                            val.imgs=val.img.split(',')||[];
                            return val;
                        })
                    }
                })
            },
            deleteCase(row){
                deleteSiteCase({case_id:row.case_id}).then(res=>{
                    if(res.code==1){
                        this.$message.success('删除成功')
                        this.getCase();
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            addCase(){
                this.$router.push({path: '/uploadFile/add',query:{name:this.sc_name,id:this.space_id}});
            },
            updateCase(row){
                this.$router.push({path: '/uploadFile/add',query:{name:this.sc_name,id:this.space_id,cid:row.case_id}});
            }
        }
    }
</script>

<style scoped>

</style>
